import { useContext } from 'react';
import { ConsentContext } from '../context/ConsentContext';

/**
 * Hook to access consent states and utilities
 * 
 * @returns {Object} Object containing consent states and methods
 */
export const useConsent = () => {
  const context = useContext(ConsentContext);
  
  if (!context) {
    throw new Error('useConsent must be used within a ConsentProvider');
  }
  
  return context;
};

/**
 * Hook for chat cookie consent - convenience wrapper for functional consent
 * Simplified to focus only on the functional consent needed for chat cookies
 * 
 * @returns {Object} Object containing chat cookie consent state and utilities
 */
export const useChatConsent = () => {
  const context = useContext(ConsentContext);
  
  if (!context) {
    throw new Error('useChatConsent must be used within a ConsentProvider');
  }
  
  const { functionalConsent, consentLoaded, openPreferences } = context;
  
  return {
    hasConsent: functionalConsent,
    consentLoaded,
    openPreferences
  };
};

/**
 * Hook for cookie consent management - alias for legacy compatibility
 * @deprecated Use useChatConsent instead
 */
export const useCookieConsent = useChatConsent;
